import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import './styles/e3d-theme.css';
import { bootstrapAppTheme } from './hooks/useAppTheme';

// Apply the stored visual theme (e3d / default) before the first render to
// avoid a flash of unthemed content on reload.
bootstrapAppTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);